/* =========================================================
	SITE-WIDE SCRIPTS
	- Alpine JS
	- AOS
	- Swiper JS
	- Sticky nav on scroll up
	- Table scroll shadow
========================================================= */

// Alpine JS
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'

Alpine.plugin(collapse)
Alpine.plugin(focus)
window.Alpine = Alpine
Alpine.start()

// AOS
import AOS from 'aos'
AOS.init();

// Swiper JS
// Import Swiper per template to avoid conflicts between carousels/sliders
// import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


import './includes/sticky-nav-on-scroll-up';
import './includes/table-scroll-shadow';
import './includes/sticky-competitor-matrix-on-scroll';
// import './includes/hide-campaign-banner';
